import React from "react";

import topImage from "../../../assets/EMP_GroceryTrustedSection/tips-promo-banner-inpage.webp";

import logosImg from "../../../assets/EMP_GroceryTrustedSection/logos-groceries-desktop.webp";
import logosImgmobile from "../../../assets/EMP_GroceryTrustedSection/logos-groceries-mobile.webp";

export default function GroceryTrustedSection() {
  return (
    <>
      {/* TOP PROMO SECTION */}
   <section
  className="
    hidden lg:block
    relative
    left-1/2
    right-1/2
    -ml-[50vw]
    -mr-[50vw]
    w-screen
    bg-[#d0e3f1]
    overflow-visible
    py-4
    lg:mt-[200px]
    lg:h-[100px]
  "
>
  <div
    className="
      w-full
      lg:w-full
      flex
      flex-col
      lg:flex-row
      items-center
      justify-between
      gap-10
      px-6
      lg:px-20
    "
  >
    {/* LEFT PHONE IMAGE */}
    <div
      className="
        lg:w-[35%]
        relative
        flex
        justify-center
        overflow-visible
        lg:mb-[47px]
      "
    >
      <img
        src={topImage}
        alt=""
        className="
          w-full
          max-w-[250px]
          object-contain
          relative
          lg:-mt-[90px]
          z-20
        "
      />
    </div>

    {/* CENTER CONTENT */}
    <div className="lg:w-[45%] lg:-mt-[130px]">

      <span
        className="
          inline-block
          bg-[#d45500]
          text-white
          text-[14px]
          font-bold
          px-2.5
          py-1
          rounded-full
          -ml-[100px]
        "
      >
        New
      </span>

      <h2
        className="
          text-[#240000]
          text-[32px]
          lg:text-[20px]
          leading-[1]
          font-serif
          lg:-ml-[100px]
          lg:mt-[15px]
        "
        style={{
        //   fontFamily: "'Cormorant Garamond', serif",
        }}
      >
        DailyPay Tips
      </h2>

      <p
        className="
          mt-1
          text-[#120000]
          text-[18px]
          lg:text-[16px]
          leading-[1.5]
          max-w-[650px]
          lg:-ml-[100px]
        "
      >
        Introducing real-time digital tips access powered by
        DailyPay.
      </p>
    </div>

    {/* RIGHT BUTTON */}
    <div className="lg:w-[20%] flex justify-center lg:justify-start -mt-[80px]">
      <button
        className="
          border-2
          border-[#16244d]
          text-[#16244d]
          hover:bg-[#16244d]
          hover:text-white
          px-4
          py-2
          rounded-full
          text-[18px]
          font-semibold
          transition-all
          duration-300
        "
      >
        Learn More
      </button>
    </div>
  </div>
</section>
<section
  className="
   relative
    left-1/2
    right-1/2
    -ml-[50vw]
    -mr-[50vw]
    w-screen
    bg-[white]
    overflow-visible
    lg:py-24
    py-16
    px-6
    lg:px-20
  "
>
  <div className="w-full text-center">

    {/* HEADING */}
    <h1
      className="
        text-[#240000]
        text-[40px]
        md:text-[40px]
        lg:text-[40px]
        leading-[1]
        font-[500]
        tracking-tight
      "
      style={{
        fontFamily: "'Cormorant Garamond', serif",
      }}
    >
      Leading Grocers and Supermarkets
      <br />
      Choose DailyPay
    </h1>

    {/* SUBTEXT */}
    <p
      className="
        mt-4
        text-[#330707]
        text-[17px]
        md:text-[16px]
        lg:text-[18px]
        leading-[1]
       font-sans
      "
    >
      Top eateries trust DailyPay to deliver on-demand
      pay to their employees
    </p>

    {/* COMBINED LOGOS IMAGE */}
    {/* MOBILE LOGOS */}
<div
  className="
    mt-10
    flex
    justify-center
    md:hidden
  "
>
  <img
    src={logosImgmobile}
    alt="Trusted Grocery Logos Mobile"
    className="
      w-full
      max-w-[340px]
      object-contain
    "
  />
</div>

{/* DESKTOP LOGOS */}
<div
  className="
    hidden
    lg:flex
    mt-10
    justify-center
  "
>
  <img
    src={logosImg}
    alt="Trusted Grocery Logos"
    className="
      w-full
      max-w-[1200px]
      h-[70px]
      object-contain
    "
  />
</div>

  </div>
</section>
      
    </>
  );
}